import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StowageStatusEnum } from 'src/enums/stowage/stowageStatusEnum';
import { StatusIcon, StatusNumberIcon } from './StowageStatusIcon.styles';
import { getValueOrMax } from 'src/utils/stowage/stowageOperation/rotationCallStatusesUtils';

export const StowageStatusIcon = (status: StowageStatusEnum, unfinishedTasks: number | null, operationType?: 'Loading' | 'Unloading') => {
    switch (status) {
        case StowageStatusEnum.NotApplicable:
            return (
                <StatusIcon className="status-icon status-saved">
                    <FontAwesomeIcon icon="exclamation-circle" title="No cargo operations" />
                </StatusIcon>
            );

        case StowageStatusEnum.MissingStowage:
            if (unfinishedTasks !== null) {
                return (
                    <StatusNumberIcon
                        className="status-icon status-missing"
                        title={`${unfinishedTasks} Missing or invalid stowage${unfinishedTasks > 1 ? 's' : ''}`}
                    >
                        {getValueOrMax(unfinishedTasks)}
                    </StatusNumberIcon>
                );
            } else {
                const tooltipMessage =
                    operationType === 'Unloading'
                        ? "Unload operation not fully linked to tank(s). Drag it to the correct tank(s) to mark them with 'U'"
                        : 'Missing stowage';
                return (
                    <StatusIcon className="status-icon status-missing">
                        <FontAwesomeIcon icon="exclamation-circle" title={tooltipMessage} />
                    </StatusIcon>
                );
            }

        case StowageStatusEnum.Stowed:
            return (
                <StatusIcon className="status-icon status-approved">
                    <FontAwesomeIcon icon="check-circle" title="Stowed" />
                </StatusIcon>
            );

        case StowageStatusEnum.InvalidStowage:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="Invalid Stowage: Adjust stowed amount to fix negative ‘Not Stowed’ values" />
                </StatusIcon>
            );
        case StowageStatusEnum.DifferenceStowedUnstowedStowage:
            return (
                <StatusIcon className="status-icon status-missing">
                    <FontAwesomeIcon icon="exclamation-circle" title="Difference between stowed and unstowed amount" />
                </StatusIcon>
            );
    }
};

export default StowageStatusIcon;
